import { BudgetTemplate } from 'interfaces/BudgetTemplate';
import { RepositoryParams, api } from '..';

export type DashboardFilters = {
  budgetTemplate?: BudgetTemplate;
  budgetTemplateId?: string;
  budgetTemplateName?: string;
  categoryId?: string;
  type?: string;
  costCenterExpenseId?: string;
  costCenterIncomeId?: string;
  categoryIncomeId?: string;
  categoryExpenseId?: string;
} & RepositoryParams;

export const list = async (params: DashboardFilters) => {
  const { budgetTemplateId, type } = params;
  return api.get(`/dashboard/${budgetTemplateId}`, {
    params: {
      type,
      costCenterId:
        type === 'expense'
          ? params.costCenterExpenseId
          : params.costCenterIncomeId,

      categoryId:
        type === 'expense' ? params.categoryExpenseId : params.categoryIncomeId,
    },
  });
};
